import { CustomerStripeSubscriptionSummary } from "../../../apis/billingApi";
import { STRIPE_PRICE_IDS } from "../constants/subscriptionIds";
import CoreSubscriptionCard from "./CoreSubscriptionCard";

interface CoreSubscriptionsProps {
  subscriptionSummaries: CustomerStripeSubscriptionSummary[];
}

const CoreSubscriptions = ({
  subscriptionSummaries = [],
}: CoreSubscriptionsProps) => {
  const hasActiveSubscription = (priceId: string) => {
    return subscriptionSummaries.some((summary) => summary.priceId === priceId);
  };

  const getCurrentTier = () => {
    if (
      hasActiveSubscription(STRIPE_PRICE_IDS.coreMaxAnnual) ||
      hasActiveSubscription(STRIPE_PRICE_IDS.coreMaxMonthly)
    ) {
      return "max";
    }
    if (
      hasActiveSubscription(STRIPE_PRICE_IDS.coreProAnnual) ||
      hasActiveSubscription(STRIPE_PRICE_IDS.coreProMonthly) ||
      hasActiveSubscription(STRIPE_PRICE_IDS.coreAnnualDiscounted)
    ) {
      return "pro";
    }
    return "free";
  };

  const getActiveProPriceId = () => {
    const proPriceIds = [
      STRIPE_PRICE_IDS.coreAnnualDiscounted,
      STRIPE_PRICE_IDS.coreProAnnual,
      STRIPE_PRICE_IDS.coreProMonthly,
    ];
    return (
      proPriceIds.find((priceId) => hasActiveSubscription(priceId)) ||
      STRIPE_PRICE_IDS.coreProMonthly
    );
  };

  const currentTier = getCurrentTier();
  const coreProPriceId = getActiveProPriceId();
  const coreMaxPriceId = hasActiveSubscription(STRIPE_PRICE_IDS.coreMaxAnnual)
    ? STRIPE_PRICE_IDS.coreMaxAnnual
    : STRIPE_PRICE_IDS.coreMaxMonthly;

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-4">
      {currentTier === "free" && (
        <CoreSubscriptionCard
          hasActiveSubscription={hasActiveSubscription(
            STRIPE_PRICE_IDS.coreFree,
          )}
          priceId={STRIPE_PRICE_IDS.coreFree}
        />
      )}

      {(currentTier === "free" || currentTier === "pro") && (
        <CoreSubscriptionCard
          hasActiveSubscription={hasActiveSubscription(coreProPriceId)}
          priceId={coreProPriceId}
        />
      )}

      <CoreSubscriptionCard
        hasActiveSubscription={hasActiveSubscription(coreMaxPriceId)}
        priceId={coreMaxPriceId}
      />
    </div>
  );
};

export default CoreSubscriptions;
